import { FormGroup, Label } from "reactstrap";
import { useEffect, useState } from "react";
import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'

const ReactDropdownTreeSelect = ({
  input,
  label,
  options,
  meta: { touched, error },
  helpText,
  className,
  disabled,
  textBlur,
  mode,
  recipientValue,
  setInList
}: any) => {
  const [data, setData] = useState<any>([]);

  const modifyRecipientMap = (userId: string) => {
    return options?.map((each: any) => ({
      ...each,
      children: each?.children?.map((eachChild: any) => {
        if (eachChild?.value === userId) {
          setInList(true);
          return {...eachChild, isDefaultValue: true}
        } else {
          return eachChild;
        }
      })
    }));
  }

  useEffect(() => {
    // add default based on values passed - keep data const
    if (options?.length > 0 && recipientValue) {
      const userValue = typeof recipientValue === "string" ? recipientValue : recipientValue?.value;
      const modifiedOptions = modifyRecipientMap(userValue);
      if (modifiedOptions) {
        setData(modifiedOptions)
      } else {
        setData(options)
      }
      setInList(true);
    } else if (options?.length > 0 && !recipientValue) {
      setData(options)
    } else {
      setData([]);
      setInList(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options, recipientValue])

  const handleChange = (value: any) => {
    if (value?.isDefaultValue) {
      input.onChange('');
      input.onBlur('');
    } else {
      input.onChange(value);
    }
  }

  return (
    <FormGroup className="select-option">
      {label && <Label for="select">{label}</Label>}
      <DropdownTreeSelect 
        data={data} 
        mode={mode}
        className={className}
        disabled={disabled}
        texts={{ placeholder: helpText }}
        onChange={handleChange}
        onBlur={() => {
          if (textBlur) textBlur();
          input.onBlur();
        }}
      />
      {touched && error && input.value === '' ? (
        <h6 className="danger">{error}</h6>
      ) : (
        ""
      )}
    </FormGroup>
  );
};
export default ReactDropdownTreeSelect;
